/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from '../../common/I18n';
import { TextArea, Button, Typography } from '../../common/UIComponents';
import Button_v2 from '../../stories/components/Button_v2';

const ReasonWindow = ({
  reasonElement, reasonValue = '', handleOnChange, closeReasonModal, 
  saveReason, showButtons = true, showCancel= true,inProgress=false
}) => (
  <div>
    <Fragment>
      <TextArea
        rows={4}
        placeholder={I18n.t("general.reason_placeholder")}
        className='sop-form-textArea'
        value={reasonValue}
        onChange={e => handleOnChange(reasonElement, e.target.value)}
      />
      <div style={{ textAlign: 'right', marginTop: '16px'}}>
        {
          showButtons !== false && 
          <Fragment>
          {
            showCancel && 
            <Button_v2
              onClick={closeReasonModal}
              className="flat medium-btn"
              text={I18n.t('general.close')}
              style={{marginRight: '16px'}}
            />
          }
          <Button_v2
            onClick={saveReason}
            disabled={reasonValue.length < 10 || reasonValue===false}
            loading={inProgress}
            className="medium-btn raised"
            text={I18n.t('general.save')}
          />
          </Fragment>
        }
        
        {false && <Typography.Paragraph className="notes_content">
          <b>
            <span className="textRed">Note</span>
          </b> :
          Reason should be minimum of 10 characters.
        </Typography.Paragraph>
        }
      </div>
    </Fragment>
  </div>
);


export default ReasonWindow;

ReasonWindow.propTypes = {
  reasonValue: PropTypes.string.isRequired,
  reasonElement: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  saveReason: PropTypes.func.isRequired,
  closeReasonModal: PropTypes.func,
};

ReasonWindow.defaultProps = {
  closeReasonModal: null,
};

